export enum DropdownTypes {
	BUTTON = 'button',
	ICON = 'icon',
	TEXT = 'text',
}
